<p-togglebutton
  [formControl]="this.control()"
  [offLabel]="'todo.public' | translate"
  [onLabel]="'todo.private' |translate"
  class="w-36 h-[38px]"
  offIcon="pi pi-lock-open"
  onIcon="pi pi-lock"
/>
